// docs: https://github.com/altostra/type-validations#readme
import { objectOf, enumOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { ApprovalStatus } from "./types";
import { approvalStatuses } from "./types";

export const isSingleApprovalRecord = objectOf({
  status: enumOf<ApprovalStatus>(approvalStatuses.PENDING, approvalStatuses.APPROVED, approvalStatuses.DECLINED),
  developer_id: string,
});
